export default {
  setTypes(state, types) {
    state.types = types
    state.typesLoaded = true
  },
  clearTypes(state) {
    state.types = []
    state.typesLoaded = false
  },
  setLocales(state, locales) {
    state.locales = locales
    state.localesLoadedAt = Date.now()
  },
  clearLocales(state) {
    state.locales = []
    state.localesLoadedAt = 0
  },
}